import tableApiCredentialsKeys from './tableApiCredentialsKeys';

export default {
  title: 'Api Keys',
  noArea: true,
  attributeName: 'key',
  getURL: 'key',
  createURL: 'key',
  removeURL: 'key',
  sessionParams: [],
  tableConfig: tableApiCredentialsKeys,
  autoUpdate: false,
};

